<div class="access-denied">
  <div class="access-denied-card">
    <h2>{{ 'appointments.gui.access.Access denied' | translate }}</h2>
    <p>{{ 'appointments.gui.access.No permission' | translate }}</p>
    <button class="blue-btn" (click)="redirectAdministration()">
      ← {{ 'appointments.gui.access.Back to system' | translate }} {{ getButtonText() }}
    </button>
  </div>
</div>
